!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.window = e.window || {});
}(this, function (e) {
  "use strict";

  var n = function () {
    function e(e) {
      if (this._cancelCallback = e, "[object Function]" !== Object.prototype.toString.call(this._cancelCallback)) throw new Error("callback must be a function");
    }

    return e.prototype.cancel = function () {
      void 0 !== this._cancelCallback && (this._cancelCallback(), this._cancelCallback = void 0);
    }, e;
  }(),
      h = 10,
      f = "0123456789bcdefghjkmnpqrstuvwxyz",
      u = 40007860,
      y = 110574,
      _ = 5,
      l = 22 * _,
      o = 6378137,
      i = .00669447819799,
      a = 1e-12;

  function d(e) {
    return Math.log(e) / Math.log(2);
  }

  function p(e, t) {
    var r;
    if (void 0 === t && (t = !1), "string" != typeof e ? r = "key must be a string" : 0 === e.length ? r = "key cannot be the empty string" : 755 < 1 + h + e.length ? r = "key is too long to be stored in Firebase" : /[\[\].#$\/\u0000-\u001F\u007F]/.test(e) && (r = "key cannot contain any of the following characters: . # $ ] [ /"), void 0 === r || t) return !r;
    throw new Error("Invalid GeoFire key '" + e + "': " + r);
  }

  function v(e, t) {
    var r;
    if (void 0 === t && (t = !1), e) {
      if (void 0 === e.latitude) r = "latitude must exist on GeoPoint";else if (void 0 === e.longitude) r = "longitude must exist on GeoPoint";else {
        var n = e.latitude,
            o = e.longitude;
        "number" != typeof n || isNaN(n) ? r = "latitude must be a number" : n < -90 || 90 < n ? r = "latitude must be within the range [-90, 90]" : "number" != typeof o || isNaN(o) ? r = "longitude must be a number" : (o < -180 || 180 < o) && (r = "longitude must be within the range [-180, 180]");
      }
    } else r = "GeoPoint must exist";
    if (void 0 === r || t) return !r;
    throw new Error("Invalid GeoFire location: " + r);
  }

  function b(e, t) {
    var r;
    if (void 0 === t && (t = !1), "string" != typeof e) r = "geohash must be a string";else if (0 === e.length) r = "geohash cannot be the empty string";else for (var n = 0, o = e; n < o.length; n++) {
      var i = o[n];
      -1 === f.indexOf(i) && (r = "geohash cannot contain '" + i + "'");
    }
    if (void 0 === r || t) return !r;
    throw new Error("Invalid GeoFire geohash '" + e + "': " + r);
  }

  function s(e, t) {
    var r;
    if (void 0 === t && (t = !1), r = b(e.g, !0) ? null : "invalid geohash on object", r = v(e.l, !0) ? r : "invalid location on object", e && "d" in e && "object" == typeof e.d || (r = "no valid document found"), r && !t) throw new Error("Invalid GeoFirestore object: " + r);
    return !r;
  }

  function c(e, t) {
    if (void 0 === t && (t = !1), "object" != typeof e) throw new Error("QueryCriteria must be an object");
    if (void 0 === e.center && void 0 === e.radius && void 0 === e.query) throw new Error("radius and/or center must be specified");
    if (t && (void 0 === e.center || void 0 === e.radius)) throw new Error("QueryCriteria for a new query must contain both a center and a radius");
    if (!["[object Function]", "[object Null]", "[object Undefined]"].includes(Object.prototype.toString.call(e.query))) throw new Error("query of QueryCriteria must be a function");

    for (var r = 0, n = Object.keys(e); r < n.length; r++) {
      var o = n[r];
      if (!["center", "radius", "query"].includes(o)) throw new Error("Unexpected attribute '" + o + "' found in query criteria");
    }

    if (void 0 !== e.center && v(e.center), void 0 !== e.radius) {
      if ("number" != typeof e.radius || isNaN(e.radius)) throw new Error("radius must be a number");
      if (e.radius < 0) throw new Error("radius must be greater than or equal to 0");
    }
  }

  function g(e, t) {
    return !(!e || "object" != typeof e || !(t && t in e || "coordinates" in e));
  }

  function m(e) {
    if ("number" != typeof e || isNaN(e)) throw new Error("Error: degrees must be a number");
    return e * Math.PI / 180;
  }

  function k(e, t) {
    if (void 0 === t && (t = h), v(e), "number" != typeof t || isNaN(t)) throw new Error("precision must be a number");
    if (t <= 0) throw new Error("precision must be greater than 0");
    if (22 < t) throw new Error("precision cannot be greater than 22");
    if (Math.round(t) !== t) throw new Error("precision must be an integer");

    for (var r = {
      min: -90,
      max: 90
    }, n = {
      min: -180,
      max: 180
    }, o = "", i = 0, a = 0, s = 1; o.length < t;) {
      var c = s ? e.longitude : e.latitude,
          u = s ? n : r,
          l = (u.min + u.max) / 2;
      l < c ? (i = 1 + (i << 1), u.min = l) : (i = 0 + (i << 1), u.max = l), s = !s, a < 4 ? a++ : (a = 0, o += f[i], i = 0);
    }

    return o;
  }

  function w(e, t) {
    var r = m(t),
        n = Math.cos(r) * o * Math.PI / 180 * (1 / Math.sqrt(1 - i * Math.sin(r) * Math.sin(r)));
    return n < a ? 0 < e ? 360 : 0 : Math.min(360, e / n);
  }

  function C(e, t) {
    var r = w(e, t);
    return 1e-6 < Math.abs(r) ? Math.max(1, d(360 / r)) : 1;
  }

  function E(e) {
    if (e <= 180 && -180 <= e) return e;
    var t = e + 180;
    return 0 < t ? t % 360 - 180 : 180 - -t % 360;
  }

  function Q(e, t) {
    var r,
        n = t / y,
        o = Math.min(90, e.latitude + n),
        i = Math.max(-90, e.latitude - n),
        a = 2 * Math.floor((r = t, Math.min(d(u / 2 / r), l))),
        s = 2 * Math.floor(C(t, o)) - 1,
        c = 2 * Math.floor(C(t, i)) - 1;
    return Math.min(a, s, c, l);
  }

  function t(e, t) {
    v(e);
    var r,
        n,
        o,
        i,
        a,
        s,
        c,
        u,
        l = Math.max(1, Q(e, t)),
        h = Math.ceil(l / _),
        d = (r = e, o = (n = t) / y, i = Math.min(90, r.latitude + o), a = Math.max(-90, r.latitude - o), s = w(n, i), c = w(n, a), u = Math.max(s, c), [F(r.latitude, r.longitude), F(r.latitude, E(r.longitude - u)), F(r.latitude, E(r.longitude + u)), F(i, r.longitude), F(i, E(r.longitude - u)), F(i, E(r.longitude + u)), F(a, r.longitude), F(a, E(r.longitude - u)), F(a, E(r.longitude + u))]).map(function (e) {
      return function (e, t) {
        b(e);
        var r = Math.ceil(t / _);
        if (e.length < r) return [e, e + "~"];
        var n = (e = e.substring(0, r)).substring(0, e.length - 1),
            o = f.indexOf(e.charAt(e.length - 1)),
            i = t - n.length * _,
            a = _ - i,
            s = o >> a << a,
            c = s + (1 << a);
        return 31 < c ? [n + f[s], n + "~"] : [n + f[s], n + f[c]];
      }(k(e, h), l);
    });
    return d.filter(function (r, n) {
      return !d.some(function (e, t) {
        return t < n && r[0] === e[0] && r[1] === e[1];
      });
    });
  }

  function G(e, t, r) {
    return v(e), b(t), {
      g: t,
      l: e,
      d: r
    };
  }

  function j(t) {
    if (t.d, 0 !== t.d.length) {
      var r = t.d;
      delete t.d, Object.keys(r).forEach(function (e) {
        t["d." + e] = r[e];
      });
    }

    return t;
  }

  function M(e) {
    var t;
    return "string" != typeof e.id && null !== e.id || (t = e.id), t;
  }

  function x(e, t) {
    var r, n;
    if (e && "object" == typeof e ? t && t in e ? n = t : "coordinates" in e ? n = "coordinates" : r = "no valid key exists" : r = "document not an object", n && !v(e[n], !0) && (r = n + " is not a valid GeoPoint"), r) throw new Error("Invalid GeoFirestore document: " + r);
    return n;
  }

  function F(e, t) {
    var r = {
      latitude: e,
      longitude: t
    };
    return v(r), r;
  }

  var r = function () {
    function e(e, t) {
      var r = this;
      if (this._collectionRef = e, this._callbacks = {
        ready: [],
        error: [],
        key_entered: [],
        key_exited: [],
        key_moved: [],
        key_modified: []
      }, this._cancelled = !1, this._currentGeohashesQueried = new Map(), this._locationsTracked = new Map(), this._valueEventFired = !1, this._geohashCleanupScheduled = !1, "[object Object]" !== Object.prototype.toString.call(this._collectionRef)) throw new Error("firebaseRef must be an instance of Firestore");
      this._cleanUpCurrentGeohashesQueriedInterval = setInterval(function () {
        !1 === r._geohashCleanupScheduled && r._cleanUpCurrentGeohashesQueried();
      }, 1e4), c(t, !0), this._center = t.center, this._radius = t.radius, this._query = t.query ? t.query(this._collectionRef) : this._collectionRef, this._listenForNewGeohashes();
    }

    return e.prototype.cancel = function () {
      var t = this;
      this._cancelled = !0, this._callbacks = {
        ready: [],
        error: [],
        key_entered: [],
        key_exited: [],
        key_moved: [],
        key_modified: []
      }, Array.from(this._currentGeohashesQueried.keys()).forEach(function (e) {
        t._cancelGeohashQuery(t._currentGeohashesQueried.get(e)), t._currentGeohashesQueried.delete(e);
      }), this._locationsTracked = new Map(), clearInterval(this._cleanUpCurrentGeohashesQueriedInterval);
    }, e.prototype.center = function () {
      return this._center;
    }, e.prototype.on = function (e, r) {
      var t = this;
      if (-1 === ["ready", "error", "key_entered", "key_exited", "key_moved", "key_modified"].indexOf(e)) throw new Error("event type must be 'ready', 'error', 'key_entered', 'key_exited', 'key_moved', or 'key_modified'");
      if ("function" != typeof r) throw new Error("callback must be a function");
      return this._callbacks[e].push(r), "key_entered" === e && this._locationsTracked.forEach(function (e, t) {
        void 0 !== e && e.isInQuery && r(t, e.document, e.distanceFromCenter);
      }), "ready" === e && this._valueEventFired && r(), new n(function () {
        t._callbacks[e].splice(t._callbacks[e].indexOf(r), 1);
      });
    }, e.prototype.query = function () {
      return this._query;
    }, e.prototype.radius = function () {
      return this._radius;
    }, e.prototype.updateCriteria = function (e) {
      c(e), this._center = e.center || this._center, this._radius = e.radius || this._radius, this._query = e.query ? e.query(this._collectionRef) : this._query, "[object Null]" === Object.prototype.toString.call(e.query) && (this._query = this._collectionRef);

      for (var t = 0, r = Array.from(this._locationsTracked.keys()); t < r.length; t++) {
        var n = r[t];
        if (!0 === this._cancelled) break;

        var o = this._locationsTracked.get(n),
            i = o.isInQuery;

        o.distanceFromCenter = R.distance(o.location, this._center), o.isInQuery = o.distanceFromCenter <= this._radius, i && !o.isInQuery ? this._fireCallbacksForKey("key_exited", n, o.document, o.distanceFromCenter) : !i && o.isInQuery && this._fireCallbacksForKey("key_entered", n, o.document, o.distanceFromCenter);
      }

      this._valueEventFired = !1, this._listenForNewGeohashes();
    }, e.prototype._cancelGeohashQuery = function (e) {
      e.childCallback(), e.valueCallback();
    }, e.prototype._childAddedCallback = function (e) {
      var t = e.exists ? e.data() : null,
          r = t && s(t) ? t.d : null,
          n = t && v(t.l) ? t.l : null;

      this._updateLocation(M(e), n, r);
    }, e.prototype._childChangedCallback = function (e) {
      var t = e.exists ? e.data() : null,
          r = t && s(t) ? t.d : null,
          n = t && v(t.l) ? t.l : null;

      this._updateLocation(M(e), n, r, !0);
    }, e.prototype._childRemovedCallback = function (e) {
      var i = this,
          a = M(e);
      this._locationsTracked.has(a) && this._collectionRef.doc(a).get().then(function (e) {
        var t = e.exists ? e.data() : null,
            r = t && s(t) ? t.d : null,
            n = t && v(t.l) ? t.l : null,
            o = null !== n ? k(n) : null;
        i._geohashInSomeQuery(o) || i._removeLocation(a, r);
      });
    }, e.prototype._cleanUpCurrentGeohashesQueried = function () {
      var r = this,
          e = Array.from(this._currentGeohashesQueried.keys());
      e.forEach(function (e) {
        var t = r._currentGeohashesQueried.get(e);

        !1 === t.active && (r._cancelGeohashQuery(t), r._currentGeohashesQueried.delete(e));
      }), (e = Array.from(this._locationsTracked.keys())).forEach(function (e) {
        if (!r._geohashInSomeQuery(r._locationsTracked.get(e).geohash)) {
          if (r._locationsTracked.get(e).isInQuery) throw new Error("Internal State error, trying to remove location that is still in query");

          r._locationsTracked.delete(e);
        }
      }), this._geohashCleanupScheduled = !1, null !== this._cleanUpCurrentGeohashesQueriedTimeout && (clearTimeout(this._cleanUpCurrentGeohashesQueriedTimeout), this._cleanUpCurrentGeohashesQueriedTimeout = null);
    }, e.prototype._fireCallbacksForKey = function (e, t, r, n) {
      this._callbacks[e].forEach(function (e) {
        null == r ? e(t, null, null) : e(t, r, n);
      });
    }, e.prototype._fireErrorEventCallbacks = function (t) {
      this._callbacks.error.forEach(function (e) {
        return e(t);
      });
    }, e.prototype._fireReadyEventCallbacks = function () {
      this._callbacks.ready.forEach(function (e) {
        return e();
      });
    }, e.prototype._geohashInSomeQuery = function (e) {
      for (var t = 0, r = Array.from(this._currentGeohashesQueried.keys()); t < r.length; t++) {
        var n = r[t];

        if (this._currentGeohashesQueried.has(n)) {
          var o = this._stringToQuery(n);

          if (e >= o[0] && e <= o[1]) return !0;
        }
      }

      return !1;
    }, e.prototype._geohashQueryReadyCallback = function (e) {
      var t = this._outstandingGeohashReadyEvents.indexOf(e);

      -1 < t && this._outstandingGeohashReadyEvents.splice(t, 1), this._valueEventFired = 0 === this._outstandingGeohashReadyEvents.length, this._valueEventFired && this._fireReadyEventCallbacks();
    }, e.prototype._listenForNewGeohashes = function () {
      var i = this,
          n = t(this._center, 1e3 * this._radius).map(this._queryToString);
      n = n.filter(function (e, t) {
        return n.indexOf(e) === t;
      }), this._currentGeohashesQueried.forEach(function (e, t) {
        var r = n.indexOf(t);
        -1 === r ? e.active = !1 : (e.active = !0, n.splice(r, 1));
      }), !1 === this._geohashCleanupScheduled && 25 < this._currentGeohashesQueried.size && (this._geohashCleanupScheduled = !0, this._cleanUpCurrentGeohashesQueriedTimeout = setTimeout(this._cleanUpCurrentGeohashesQueried, 10)), this._outstandingGeohashReadyEvents = n.slice(), n.forEach(function (r) {
        var e = i._stringToQuery(r),
            n = i._query.where("g", ">=", e[0]).where("g", "<=", e[1]),
            o = n.onSnapshot(function (e) {
          ("function" == typeof e.docChanges ? e.docChanges() : e.docChanges).forEach(function (e) {
            "added" === e.type && i._childAddedCallback(e.doc), "modified" === e.type && i._childChangedCallback(e.doc), "removed" === e.type && i._childRemovedCallback(e.doc);
          });
          var t = n.onSnapshot(function () {
            t(), i._geohashQueryReadyCallback(r);
          });

          i._currentGeohashesQueried.set(r, {
            active: !0,
            childCallback: o,
            valueCallback: t
          });
        }, function (e) {
          return i._fireErrorEventCallbacks(e);
        });
      }), 0 === n.length && this._geohashQueryReadyCallback();
    }, e.prototype._queryToString = function (e) {
      if (2 !== e.length) throw new Error("Not a valid geohash query: " + e);
      return e[0] + ":" + e[1];
    }, e.prototype._removeLocation = function (e, t) {
      var r = this._locationsTracked.get(e);

      if (this._locationsTracked.delete(e), void 0 !== r && r.isInQuery) {
        var n = t ? x(t) : null,
            o = n ? t[n] : null,
            i = o ? R.distance(o, this._center) : null;

        this._fireCallbacksForKey("key_exited", e, t, i);
      }
    }, e.prototype._stringToQuery = function (e) {
      var t = e.split(":");
      if (2 !== t.length) throw new Error("Invalid internal state! Not a valid geohash query: " + e);
      return t;
    }, e.prototype._updateLocation = function (e, t, r, n) {
      var o, i;
      void 0 === n && (n = !1), v(t);

      var a = !!this._locationsTracked.has(e) && this._locationsTracked.get(e).isInQuery,
          s = this._locationsTracked.has(e) ? this._locationsTracked.get(e).location : null;

      i = (o = R.distance(t, this._center)) <= this._radius, this._locationsTracked.set(e, {
        distanceFromCenter: o,
        document: r,
        geohash: k(t),
        isInQuery: i,
        location: t
      }), i && !a ? this._fireCallbacksForKey("key_entered", e, r, o) : !i || null === s || t.latitude === s.latitude && t.longitude === s.longitude ? !i && a ? this._fireCallbacksForKey("key_exited", e, r, o) : i && n && this._fireCallbacksForKey("key_modified", e, r, o) : this._fireCallbacksForKey("key_moved", e, r, o);
    }, e;
  }(),
      R = function () {
    function e(e) {
      if (this._collectionRef = e, "[object Object]" !== Object.prototype.toString.call(this._collectionRef)) throw new Error("collectionRef must be an instance of a Firestore Collection");
      this._isWeb = "[object Function]" === Object.prototype.toString.call(this._collectionRef.firestore.enablePersistence);
    }

    return e.prototype.add = function (e, t) {
      if ("[object Object]" !== Object.prototype.toString.call(e)) throw new Error("document must be an object");
      var r = e[x(e, t)],
          n = k(r);
      return this._collectionRef.add(G(r, n, e));
    }, e.prototype.get = function (e, t) {
      void 0 === t && (t = {
        source: "default"
      }), p(e);

      var r = this._collectionRef.doc(e);

      return (this._isWeb ? r.get(t) : r.get()).then(function (e) {
        return e.exists ? function (e) {
          if (s(e, !0)) return e.d;
          throw new Error("Unexpected location object encountered: " + JSON.stringify(e));
        }(e.data()) : null;
      });
    }, e.prototype.ref = function () {
      return this._collectionRef;
    }, e.prototype.remove = function (e) {
      if (Array.isArray(e)) {
        var t = {};
        return e.forEach(function (e) {
          t[e] = null;
        }), this.set(t);
      }

      return this.set(e);
    }, e.prototype.query = function (e) {
      return new r(this._collectionRef, e);
    }, e.prototype.set = function (e, t, r) {
      return this._write("set", e, t, r);
    }, e.prototype.update = function (e, t, r) {
      return this._write("update", e, t, r);
    }, e.prototype._write = function (a, s, e, c) {
      var u = this;

      if ("string" == typeof s && 0 !== s.length) {
        if (p(s), e) {
          if ("update" === a && !g(e, c)) return this._collectionRef.doc(s).update(j({
            d: e
          }));
          var t = e[x(e, c)],
              r = k(t);
          if ("update" !== a) return this._collectionRef.doc(s).set(G(t, r, e));
          var n = G(t, r, e);
          return this._collectionRef.doc(s).update(j(n));
        }

        return this._collectionRef.doc(s).delete();
      }

      if ("object" != typeof s) throw new Error("keyOrDocuments must be a string or a mapping of key - document pairs.");
      if (void 0 !== e) throw new Error("The location argument should not be used if you pass an object to set().");

      var l = this._collectionRef.firestore.batch();

      return Object.keys(s).forEach(function (e) {
        p(e);

        var t = u._collectionRef.doc(e),
            r = s[e];

        if (r) {
          if ("update" !== a || g(r, c)) {
            var n = r[x(r, c)],
                o = k(n);

            if ("update" === a) {
              var i = G(n, o, r);
              l.update(t, j(i));
            } else l.set(t, G(n, o, r));
          } else l.update(t, j({
            d: r
          }));
        } else l.delete(t);
      }), l.commit();
    }, e.distance = function (e, t) {
      v(e), v(t);
      var r = m(t.latitude - e.latitude),
          n = m(t.longitude - e.longitude),
          o = Math.sin(r / 2) * Math.sin(r / 2) + Math.cos(m(e.latitude)) * Math.cos(m(t.latitude)) * Math.sin(n / 2) * Math.sin(n / 2);
      return 6371 * (2 * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o)));
    }, e;
  }();

  e.GeoCallbackRegistration = n, e.GeoFirestore = R, e.GeoFirestoreQuery = r, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});